<nav class="nav">
  <div class="nav-inner">
    <div class="nav-logo">
      <a href="/">
        <img src="https://harryhallinsurance.com/wp-content/uploads/2024/05/harry-hall-insurance-logo-e1714570462131.webp" alt="Harry Hall Insurance"
        />
      </a>
    </div>
    <a class="nav-btn" [href]="portalUrl + '/#/pages/login'"
      >Login <span class="nav-btn-arrow">→</span></a
    >
  </div>
</nav>
